import Box from "@mui/material/Box";
import { Minus, Plus } from "lucide-react";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_ZOOM_FIT,
  TEMPLATES_ZOOM_IN,
  TEMPLATES_ZOOM_OUT,
} from "../../../i18n/keysTranslations";
import { MIN_ZOOM, MAX_ZOOM } from "./useCanvasZoom";

const zoomControlSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 28,
  height: 28,
  px: 0.5,
  border: 0,
  borderRadius: "7px",
  bgcolor: "transparent",
  color: "#18181B",
  cursor: "pointer",
  appearance: "none",
  fontFamily: "inherit",
  fontSize: "12px",
  fontWeight: 600,
  "&:hover": { bgcolor: "#F4F4F5" },
  "&:disabled": { opacity: 0.35, cursor: "default", bgcolor: "transparent" },
};

const ZoomControls = ({ zoom, onZoomIn, onZoomOut, onFit }) => {
  const { t } = useTranslationApp();
  return (
    <Box
      onPointerDown={(event) => event.stopPropagation()}
      sx={{
        position: "absolute",
        right: 12,
        bottom: 12,
        zIndex: 6,
        display: "flex",
        alignItems: "center",
        gap: 0.25,
        px: 0.5,
        py: 0.25,
        bgcolor: "#fff",
        border: "1px solid #E4E4E7",
        borderRadius: "10px",
        boxShadow: "0 4px 16px rgba(24,24,27,.08)",
      }}
    >
      <Box
        component="button"
        type="button"
        title={t(TEMPLATES_ZOOM_OUT)}
        aria-label={t(TEMPLATES_ZOOM_OUT)}
        disabled={zoom <= MIN_ZOOM + 0.001}
        onClick={onZoomOut}
        sx={zoomControlSx}
      >
        <Minus size={14} />
      </Box>
      <Box
        component="button"
        type="button"
        title={t(TEMPLATES_ZOOM_FIT)}
        aria-label={t(TEMPLATES_ZOOM_FIT)}
        onClick={onFit}
        sx={{ ...zoomControlSx, minWidth: 48 }}
      >
        {`${Math.round(zoom * 100)}%`}
      </Box>
      <Box
        component="button"
        type="button"
        title={t(TEMPLATES_ZOOM_IN)}
        aria-label={t(TEMPLATES_ZOOM_IN)}
        disabled={zoom >= MAX_ZOOM - 0.001}
        onClick={onZoomIn}
        sx={zoomControlSx}
      >
        <Plus size={14} />
      </Box>
    </Box>
  );
};

export default ZoomControls;
